import { api_GET, api_POST, api_PUT } from "./_api.js";

const perfil_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Perfil")
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Perfil/GetItem/${id}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Perfil", json)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Perfil", json)
            .then(result => resolve(result))
            .catch(result => reject(result));
        });
        return promise;
    },
    PostPermissoes: (id, funcionalidadeAcos) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Perfil/PostPermissoes/${id}`, funcionalidadeAcos)
            .then(result => {
                resolve(result)
            })
            .catch(result => reject(result));
        });
        return promise;
    },
    PostPerfilFiscalizacaoEtapa: (id, funcionalidadeetapas) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Perfil/PostPerfilFiscalizacaoEtapa/${id}`, funcionalidadeetapas)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default perfil_api;
